export default __webpack_public_path__ + "static/media/tree.df447c52.svg";